/*
|
|--------------------------------------------------------------------------
| Page Transitions
|--------------------------------------------------------------------------
| This controls what Barba.js transition to based on three factors
| 1: Does the link clicked have the attribute page-transition
| 2: If not, see if there is a transition for the name space
| 3: If neither correspond default to a transition
|
*/



Barba.Pjax.getTransition = function() {

    const pageTransition = lastClickEl.getAttribute('barba-transition')


    const nameSpace = Barba.HistoryManager.prevStatus().namespace ;


//|--------------------------------------------------------------------------
//| Check page transition based on link clicked
//|--------------------------------------------------------------------------
    if (pageTransition === 'sibling-fade') {
        return SiblingFadeTransition;
    }

    if (pageTransition === 'category-to-category') {
        return CategoryToCategory;
    }

//|--------------------------------------------------------------------------
//| If no page transition use Name Space
//|--------------------------------------------------------------------------


    if (nameSpace === 'frontpage') {
        return FadeTransition;
    }

//|--------------------------------------------------------------------------
//| If all fails default to transition
//|--------------------------------------------------------------------------
    return FadeTransition;

};